import { _mock } from './_mock';
import { _userList } from './_user';

// ----------------------------------------------------------------------

export const JWT_SECRET = 'jwt-secret-key';
export const JWT_EXPIRES_IN = '5 days';

// Simple token generator for development
const generateToken = (userId: string) => {
  // In a real implementation, this would use jsonwebtoken
  // For development, we'll just create a simple encoded string
  const payload = { userId };
  const base64Payload = btoa(JSON.stringify(payload));
  return `dev.${base64Payload}.token`;
};

// Simple token verification for development
const verifyToken = (token: string) => {
  try {
    // In a real implementation, this would use jsonwebtoken
    // For development, we'll just decode the simple string
    const parts = token.split('.');
    if (parts.length !== 3 || parts[0] !== 'dev') {
      throw new Error('Invalid token format');
    }
    const payload = JSON.parse(atob(parts[1]));
    return payload;
  } catch (error) {
    throw new Error('Invalid token');
  }
};

// ----------------------------------------------------------------------

export const _users = _userList.map((user) => ({
  id: user.id,
  displayName: user.name,
  email: user.email,
  password: '123456',
  photoURL: user.avatarUrl,
  phoneNumber: user.phoneNumber,
  country: user.country,
  address: user.address,
  state: user.state,
  city: user.city,
  zipCode: user.zipCode,
  about: _mock.jobTitle(10),
  role: user.role,
  isPublic: true,
}));

// ----------------------------------------------------------------------

export const mockLogin = (email: string, password: string) => {
  const user = _users.find((useri) => useri.email === email);

  if (!user) {
    return { status: 400, data: { message: 'User not found' } };
  }

  if (password !== '123456') {
    return { status: 400, data: { message: 'Wrong password' } };
  }

  const accessToken = generateToken(user.id);

  return {
    status: 200,
    data: {
      accessToken,
      user: {
        id: user.id,
        displayName: user.displayName,
        email: user.email,
        photoURL: user.photoURL,
        phoneNumber: user.phoneNumber,
        country: user.country,
        address: user.address,
        state: user.state,
        city: user.city,
        zipCode: user.zipCode,
        role: user.role,
      },
    },
  };
};

// ----------------------------------------------------------------------

export const mockRegister = (
  email: string,
  password: string,
  firstName: string,
  lastName: string
) => {
  const existingUser = _users.find((user) => user.email === email);

  if (existingUser) {
    return { status: 400, data: { message: 'Email already in use' } };
  }

  const newUser = {
    id: _mock.id(Math.floor(Math.random() * 10000)),
    displayName: `${firstName} ${lastName}`,
    email,
    password,
    photoURL: _mock.image.avatar(Math.floor(Math.random() * 10)),
    phoneNumber: _mock.phoneNumber(Math.floor(Math.random() * 10)),
    country: _mock.firstName(Math.floor(Math.random() * 10)),
    address:  _mock.firstName(Math.floor(Math.random() * 10)),
    state:  _mock.firstName(Math.floor(Math.random() * 10)),
    city: _mock.firstName(Math.floor(Math.random() * 10)),
    zipCode:  _mock.firstName(Math.floor(Math.random() * 10)),
    about:  _mock.firstName(Math.floor(Math.random() * 10)),
    role: 'user',
    isPublic: true,
  };

  _users.push(newUser);

  const accessToken = generateToken(newUser.id);

  return {
    status: 200,
    data: {
      accessToken,
      user: {
        id: newUser.id,
        displayName: newUser.displayName,
        email: newUser.email,
        photoURL: newUser.photoURL,
        phoneNumber: newUser.phoneNumber,
        country: newUser.country,
        address: newUser.address,
        state: newUser.state,
        city: newUser.city,
        zipCode: newUser.zipCode,
        role: newUser.role,
      },
    },
  };
};

// ----------------------------------------------------------------------

export const mockMe = (accessToken: string) => {
  try {
    if (!accessToken) {
      return { status: 401, data: { message: 'Token not found' } };
    }

    const decoded = verifyToken(accessToken);
    const {userId} = decoded;

    const user = _users.find((useri) => useri.id === userId);

    if (!user) {
      return { status: 401, data: { message: 'Invalid token' } };
    }

    return {
      status: 200,
      data: {
        user: {
          id: user.id,
          displayName: user.displayName,
          email: user.email,
          photoURL: user.photoURL,
          phoneNumber: user.phoneNumber,
          country: user.country,
          address: user.address,
          state: user.state,
          city: user.city,
          zipCode: user.zipCode,
          role: user.role,
        },
      },
    };
  } catch (error) {
    return { status: 401, data: { message: 'Invalid token' } };
  }
};
